import { Log } from '@/shared/Log';
import { Utils } from '@/shared/Utils';

/**
 * @deprecated use shared/fetch.ts instead.
 */
export function ajaxCall(
    requestType: string,
    url: string,
    successCallBack: (data: any, textStatus: string, jqXhr: JQueryXHR) => any,
    errorCallBack?: (
        jqXhr: JQueryXHR,
        textStatus: string,
        error: string,
    ) => any,
    data?: any,
    contentType?: string,
    isAsync?: boolean,
) {
    const settings: JQueryAjaxSettings = {
        async: isAsync ? isAsync : true,
        contentType: contentType ? contentType : 'application/json',
        data,
        error: (request: JQueryXHR, status: string, error: string) => {
            if (request.status === 401) {
                Utils.logout();
                return;
            }

            if (errorCallBack) {
                errorCallBack(request, status, error);
                return;
            }

            Log.error(
                `API call failed and no error callback provided. url=${url} status=${request.status} response=${request.responseJSON}`,
            );
        },
        success: successCallBack,
        url: getApiUrl(url),
        type: requestType,
        headers: {
            'Accept-Language': 'da',
        },
    };

    $.ajax(settings);
}

function getApiUrl(url: string): string {
    return window.location.protocol + '//' + window.location.host + '/' + url;
}
